export enum ThemeName {
    Main = 'main',
    PersianGreen = 'persian-green',
    Solitude = 'solitude',
    Eastern = 'eastern',
}
